import { RefObject, useEffect } from "react";
import { BACKOFFICE_URL, EMPLOYEE_LOGIN_PROVIDER_UID, isBlockedOrg } from "~/const/employeeAccessConsts";
import { initPostAuthStore as initPostAuthStoreHelper } from "~/store/initStore";
import { LOADER_DURATION_NAMES } from "../../utils/tracking";
import { RootProps } from "./Root";

type UseRootInitializationProps = Pick<RootProps, "store" | "actions"> & {
    isPostAuthStoreInitializedRef: RefObject<boolean>;
};

const checkAndBlockEmployeeSsoRedirect = (): void => {
    // Check if we're being redirected to employee SSO login
    const currentPath = window.location.pathname;
    const isEmployeeSsoPath = currentPath.includes(EMPLOYEE_LOGIN_PROVIDER_UID);

    if (isEmployeeSsoPath && isBlockedOrg()) {
        alert("Blocked employee SSO redirect attempt for blocked org");
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = BACKOFFICE_URL;
        throw new Error("Employee SSO blocked for this organization");
    }
};

export const useRootInitialization = ({
    store,
    actions,
    isPostAuthStoreInitializedRef,
}: UseRootInitializationProps) => {
    useEffect(() => {
        const initializeRoot = async () => {
            checkAndBlockEmployeeSsoRedirect();

            actions.startLoading(LOADER_DURATION_NAMES.ROOT_LOADER);
            try {
                await actions.restoreLogin();
                await initPostAuthStoreHelper(store);
                isPostAuthStoreInitializedRef.current = true;
                actions.setIsAuthenticated(true);
            } catch {
                actions.setIsAuthenticated(false);
            } finally {
                actions.endLoading();
            }
        };

        initializeRoot();
    }, [store, actions, isPostAuthStoreInitializedRef]);
};
